module.exports = __webpack_public_path__ + "ionicons.05acfdb568b3df49ad31.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ionicons/fonts/ionicons.woff?v=2.0.0
// module id = 1198
// module chunks = 8